import { Container } from "components/layout/Container";
import { Heading } from "components/layout/Heading";
import { DefaultCard } from "components/shared/cards/DefaultCard";
import { Button } from "components/UI/Buttons/Button";
import styles from "./SectionLandingHow.module.scss";
import cn from "classnames";
import { NumberedCard } from "@/components/shared/cards/NumberedCard";

type SectionLandingHowProps = {
  heading: string;
  subheading?: string;
  items: {
    title: string;
    text: string;
  }[];
  button: {
    href: string;
    text: string;
  };
};

export const SectionLandingHow = ({ heading, subheading, button, items }: SectionLandingHowProps) => (
  <section className={styles.section}>
    <Container>
      <Heading
        title={heading}
        subheading={subheading}
        image="/img/icons/60/gear.png"
        className={styles.heading}
      />
      <ol
        className={cn(styles.items, {
          [styles.grid2]: items.length % 3 && items.length % 4,
          [styles.grid3]: !(items.length % 3),
          [styles.grid4]: !(items.length % 4),
        })}
      >
        {items.map((item, index) => (
          <NumberedCard key={index} number={index + 1} tag="li" heading={item.title} text={item.text} />
        ))}
      </ol>
      <div className={styles.btnWrap}>
        <Button href={button.href}>{button.text}</Button>
      </div>
    </Container>
  </section>
);

export default SectionLandingHow;
